export interface EchartTitleOption {
  title: string;
  xPosition: string | number;
  yPosition: string | number;
  fontSize: string;
  fontWeight: 'normal' | 'bold' | 'bolder' | 'lighter' | number;
  skipUpperCase: boolean;
}

export const EchartTitleOptionDefault: EchartTitleOption = {
  title: '',
  xPosition: undefined,
  yPosition: undefined,
  fontSize: undefined,
  fontWeight: undefined,
  skipUpperCase: false,
};
